/**
 * General Medicine Consultations Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";
import AppConfig from "../../../constants/AppConfig";
import {store} from "../../store";

// States
const state = {
    generalConsultations: [],
    generalConsultation: {}
};

// Getters
const getters = {
    generalConsultations: state => {
        return state.generalConsultations
    },

    generalConsultation: state => {
        return state.generalConsultation
    }
};

// Actions
const actions = {
    printConsultationMedecine(context, payload) {
        function successCallback(response) {
            let url= AppConfig.imgUrl+'/public/storage/pdf/'+response.data.name;
            let fileName = response.data.name;

            Vue.axios.get(
                url,{
                    responseType: 'blob', // important
                }
            ).then((response) => {
                
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', fileName);
                document.body.appendChild(link);
                link.click();
            });
        }


        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.Print, localToken, successCallback, errorCallback, payload.errorMessages);
    },


    getGeneralConsultations(context, payload) {
        function successCallback(response) {
            context.commit('getGeneralConsultationsHandler', { consultations: response.data.consultations });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    getGeneralConsultation(context, payload) {
        function successCallback(response) {
            context.commit('getGeneralConsultationHandler', { consultation: response.data.consultation });
            context.commit('getMedicalFileHandler', { file: response.data.consultation.dossier });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createGeneralConsultation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );


            //Push to list of consultation
            // router.push({ name: 'consultations-generals' });

            //Push to created consultation
            router.push({ name: 'consultation-general', params: { consultation: response.data.consultation.slug } });


        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');
        let url = AppConfig.apiUrl + apiModel.Consultation.General.Create.url;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);
        // makeApiRequest(payload.args, apiModel.Consultation.General.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    updateGeneralConsultation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            //Push to list of consultation
            // router.push({ name: 'consultations-generals' });

            //Push to edited consultation
            store.dispatch('findAndRemove', {name: 'consultation-general' });

            router.push({ name: 'consultation-general', params: { consultation: response.data.consultation.slug } });
        }

        function errorCallback(error) {
            store.dispatch('record', {errors : error.response.data.error});
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        let url = AppConfig.apiUrl + apiModel.Consultation.General.Create.url + '/' + payload.consultation;

        Vue.axios.post(
            url,
            payload.args,
            {
                headers: {
                    'Authorization': `Bearer ${localToken}`,
                    'Content-Type': 'multipart/form-data'
                }
            }
        )
            .then(successCallback)
            .catch(errorCallback);

        // makeApiRequest(payload.args, apiModel.Consultation.General.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteGeneralConsultation(context, payload) {
        function successCallback(response) {
            // context.commit('deleteGeneralConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            router.push((router.resolve({ name: 'medical-file',  params: { file: response.data.consultation.dossier.slug } }).href) +"#generale");
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createConsultationPhysicalExams(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'consultation-physical-exams' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.PhysicalExam.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteConsultationPhysicalExam(context, payload) {
        function successCallback(response) {
            context.commit('deleteConsultationPhysicalExamHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.PhysicalExam.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    createConsultationComplementaryExams(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );

            router.push({ name: 'consultation-complementary-exams' });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.ComplementaryExam.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    deleteConsultationComplementaryExam(context, payload) {
        function successCallback(response) {
            context.commit('deleteConsultationComplementaryExamHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.ComplementaryExam.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    archieveMedecineConsultation(context, payload) {
        function successCallback(response) {
            context.commit('archieveMedecineConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getGeneralConsultationHandler', { consultation: response.data.resultat });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.Archieve, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    transmitMedecineConsultation(context, payload) {
        function successCallback(response) {
            context.commit('transmitMedecineConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getGeneralConsultationHandler', { consultation: response.data.resultat });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.Transmit, localToken, successCallback, errorCallback, payload.errorMessages);
    },

    reactiveMedecineConsultation(context, payload) {
        function successCallback(response) {
            context.commit('reactiveMedecineConsultationHandler', { index: payload.index, successMessage: payload.successMessage });
            context.commit('getGeneralConsultationHandler', { consultation: response.data.resultat });

        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Consultation.General.Reactive, localToken, successCallback, errorCallback, payload.errorMessages);
    },
};

// Mutations
const mutations = {
    setAllergieHandler(state,{allergies}){
        if (state.generalConsultation.hasOwnProperty('dossier')){
            let dossier = state.generalConsultation.dossier;
            if (dossier.hasOwnProperty('allergies')){
                state.generalConsultation.dossier.allergies = allergies;
            }
        }
    },

    setAntecedentHandler(state,{antecedents}){
        if (state.generalConsultation.hasOwnProperty('dossier')){
            let dossier = state.generalConsultation.dossier;
            if (dossier.hasOwnProperty('antecedents')){
                state.generalConsultation.dossier.antecedents = antecedents;
            }
        }
    },

    getGeneralConsultationsHandler(state, { consultations }) {
        // Update generalConsultations state
        state.generalConsultations = consultations;
    },

    getGeneralConsultationHandler(state, { consultation }) {
        // Update generalConsultation state
        state.generalConsultation = consultation;
    },

    updateMedecineGeneralFileHandler(state,{files}){
        state.generalConsultation.files = files
    },

    deleteGeneralConsultationHandler(state, { index, successMessage }) {
        // let i = state.generalConsultations.findIndex(consultation => consultation.slug === index);
        //
        // if (~i) {
        //     state.generalConsultations.splice(i, 1);

        // router.push({ name: 'consultations-generals' });


        Vue.swal(
            payload.successMessage,
            '',
            'success'
        );
        // }
    },

    deleteConsultationPhysicalExamHandler(state, { index, successMessage }) {
        let i = state.physicalExams.findIndex(physicalExam => physicalExam.slug === index);

        if (~i) {
            state.physicalExams.splice(i, 1);

            router.push({ name: 'consultation-physical-exams' });

            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
        }
    },

    deleteConsultationComplementaryExamHandler(state, { index, successMessage }) {
        let i = state.complementaryExams.findIndex(complementaryExam => complementaryExam.slug === index);

        if (~i) {
            state.complementaryExams.splice(i, 1);

            router.push({ name: 'consultation-complementary-exams' });

            Vue.swal(
                successMessage,
                '',
                'error'
            );
        }
    },

    archieveMedecineConsultationHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-generals' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    reactiveMedecineConsultationHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-generals' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

    transmitMedecineConsultationHandler(state, { index, successMessage }) {
        // router.push({ name: 'consultations-generals' });

        Vue.swal(
            successMessage,
            '',
            'success'
        );
    },

};

export default {
    state,
    getters,
    actions,
    mutations
}